// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___e04df4e9c0f80612a99","cls2":"AuthorHeader-cls2___db171e8d5c908c288b9 AuthorHeader-cls1___e04df4e9c0f80612a99"};